import React, { Fragment } from 'react'
import Breadcrumbs from '../../../../CommonElements/Breadcrumbs'
import { BlogDetailsTitle, BlogTitle } from '../../../../Utils/Constants'
import { Container, Row } from 'reactstrap'
import BlogSidebar from '../Common/BlogSidebar'
import BlogContent from './BlogContent'

export default function BlogDetailsContainer() {
    return (
        <Fragment>
            <Breadcrumbs pageTitle={BlogDetailsTitle} parent={BlogTitle} title={BlogDetailsTitle} />
            <Container className="blog-detail-page" fluid>
                <Row>
                    <BlogContent />
                    <BlogSidebar />
                </Row>
            </Container>
        </Fragment>
    )
}